import React, {Component} from 'react';
import { Modal, Button, Row, Col, Form, FormGroup, FormControl, ControlLabel } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import MessageStore from '../../stores/MessageStore'
import {SubscribeStore} from '../../stores/SubscribeStore'
import {toast} from 'react-toastify';


const msgTemplate  = {
	title: 'Example Confirm Notification',
	content: 'ดูผลลัพธ์ได้ที่ https://putsreq.com/VnxVg9kePlts5MSGdDIZ/inspect',
	message_type: 'buttons',
	message_buttons: [
		{
			text: 'รับทราบ',
			style: 'primary',
			action: {
				type: 'js',
				data: {
					confirm: true,					
				},
			},
		}
	],
	options: {
		position: toast.POSITION.BOTTOM_RIGHT,
		closeOnClick: true,
		autoClose:false,
	},
}
class MessageSendModal extends Component {

  constructor(props) {
    super(props)
    this.state = {showForm:false,message:{},messageText:''}
  }

  componentWillReceiveProps(newProps){

    if(newProps.show && newProps.show!==this.props.show){
      console.log('msg',newProps.message)
      let messageText = ''
      if(newProps.mode==='read'){
        messageText = newProps.message.message.text
      }
      this.setState({message:newProps.message,messageText:messageText})
    }
  }

  onSendMsgClick(e) {
    let {message,messageText} = this.state
    let postData = {sender_id:'',recipient_id:message.sender_id,message:{type:'text',text:messageText},origin_id:message.bf_message_id}
    if(message.message.work_no!==undefined){
      postData.message.work_no = message.message.work_no
    }
    MessageStore.newMessage(postData,(result) =>{
      if (result.status==='OK'){
        postData.sender_id = result.data.sender_id
        this.sendRealtimeNoti(message.sender_id,messageText,result.msg_id)
        if(this.props.onReplySent!==undefined){
          this.props.onReplySent(postData)
        }
        this.props.onHide()        
      }
    })
  }

  sendRealtimeNoti(recipient_id,text,msg_id){
		let msg =  JSON.parse(JSON.stringify(msgTemplate))
		console.log('msg',msg)
		msg['title'] = 'ข้อความเข้า'
    msg['content'] = text    
    msg["message_buttons"][0]['action']['type'] = 'bigfix_api'
    msg["message_buttons"][0]['action']['url'] = "/message/mark_read_message/"+msg_id

    recipient_id = recipient_id.replace("@", "_");
		let send_data = {channel_id:'user/'+recipient_id,data:msg}
		this.realtime = new SubscribeStore();
		this.realtime.connect(send_data.channel_id, () => {

			this.realtime.send(send_data);
			console.log('send data', send_data);
			this.realtime.disconnect();

			this.setState({sending: false,sendJsonText:JSON.stringify(send_data)});
		});
	}

  onTextChange(key,e) {
    let state = this.state
    state[key] = e.target.value
    this.setState(state)
  }

  onModalFormOpenClick() {
    
    this.setState({showForm:true})
  }

  render() {
    let {show} = this.props    
    let {sender_name,recipient_name} = this.state.message
    let {messageText} = this.state
    let readonly  = this.props.mode==='reply' || this.props.mode==='read'
    let msgReadOnly = this.props.mode==='read'

    let title = (this.props.mode==='read')?'อ่านข้อความ':(this.props.mode==='reply')?'ตอบกลับข้อความ':'ส่งข้อความ'
    return(
      <Modal
        show={show}
        onHide={this.props.onHide}
        dialogClassName="smallwidth-dialog"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <FormGroup>
              <ControlLabel>ผู้รับ</ControlLabel>
              <FormControl value={sender_name} onChange={this.onTextChange.bind(this,'sender_name')} readOnly={readonly}/>
            </FormGroup>
            <FormGroup>
              <ControlLabel>ข้อความ</ControlLabel>
              <FormControl componentClass="textarea" value={messageText} onChange={this.onTextChange.bind(this,'messageText')} 
              readOnly={msgReadOnly}
              />
            </FormGroup>
          </Form>  
        </Modal.Body>
        <Modal.Footer>
          <Button className='btn btn-success' 
          style={{display:(this.props.mode==='read')?'none':''}}
          onClick={this.onSendMsgClick.bind(this)}><FontAwesome name='send' />&nbsp;ส่งข้อความ</Button>
          <Button onClick={this.props.onHide}><FontAwesome name='close' />&nbsp;ปิดหน้าต่าง</Button>
        </Modal.Footer>
      </Modal>
    )
  }

  

  
}

MessageSendModal.defaultProps = {
  show  : false,
  mode:''
}

export default MessageSendModal


// WEBPACK FOOTER //
// ./src/view/menu/MessageSendModal.js